import { TElement } from './types';
import { Key } from 'i18n/Key';
import { addDefaultTranslates } from 'i18n/config';
import {
  minesMultipliers,
  minesMultipliersB,
  minesMultipliersC,
  minesMultipliers_86,
  minesMultipliers_92,
  minesMultipliers_93,
  minesMultipliers_94,
  minesMultipliers_95,
} from './paytables';

import img_about1 from 'assets/images/intro/about/img_about1@2x.min.png';
import img_about2 from 'assets/images/intro/about/img_about2@2x.min.png';
import img_about3 from 'assets/images/intro/about/img_about3@2x.min.png';
import img_about4 from 'assets/images/intro/about/img_about4@2x.min.png';
import img_about5 from 'assets/images/intro/about/img_about5@2x.min.png';
import img_about6 from 'assets/images/intro/about/img_about6@2x.min.jpg';
import img_about7 from 'assets/images/intro/about/img_about7@2x.min.jpg';
import img_about8 from 'assets/images/intro/about/img_about8@2x.min.jpg';
import img_about9 from 'assets/images/intro/about/img_about9@2x.min.jpg';
import img_about10 from 'assets/images/intro/about/img_about10@2x.min.png';
import { getUrlParams } from 'shared/helpers/parseUrl';

const urlParams = getUrlParams();

addDefaultTranslates({
  [Key.img_about1]: img_about1,
  [Key.img_about2]: img_about2,
  [Key.img_about3]: img_about3,
  [Key.img_about4]: img_about4,
  [Key.img_about5]: img_about5,
  [Key.img_about6]: img_about6,
  [Key.img_about7]: img_about7,
  [Key.img_about8]: img_about8,
  [Key.img_about9]: img_about9,
  [Key.img_about10]: img_about10,
});

const gameCode: string =
  urlParams != null && urlParams.hasOwnProperty('game_code')
    ? urlParams['game_code']
    : '';

const getVersion = (gameCode: string): string => {
  switch (gameCode) {
    case 'coin_miner_86':
      return '_coin_miner_86';
    case 'mine_bomb_90':
    case 'coin_miner_90':
      return 'B';
    case 'coin_miner_92':
      return '_coin_miner_92';
    case 'coin_miner_93':
      return '_coin_miner_93';
    case 'coin_miner_94':
    case 'gold_mine_94':
      return 'C';
    case 'coin_miner_95':
      return '_coin_miner_95';
    case 'coin_miner_97':
      return '_coin_miner_97';
    default:
      return '';
  }
};

const getPaytable = (
  gameCode: string,
): { mines: number; multi: number[] }[] => {
  switch (gameCode) {
    case 'coin_miner_86':
      return minesMultipliers_86;
    case 'mine_bomb_90':
    case 'coin_miner_90':
      return minesMultipliersB;
    case 'coin_miner_92':
      return minesMultipliers_92;
    case 'coin_miner_93':
      return minesMultipliers_93;
    case 'coin_miner_94':
    case 'gold_mine_94':
      return minesMultipliersC;
    case 'coin_miner_95':
      return minesMultipliers_95;
    case 'coin_miner_97':
    default:
      return minesMultipliers;
  }
};

const versionT = getVersion(gameCode);

export const aboutRTP = `${Key.infoP10}${versionT}`;

const generatedMines = getPaytable(gameCode).map<TElement>(
  ({ mines, multi }) => ({
    type: 'table',
    content: {
      title: Key.dynamiteAmount,
      title2: ` — ${mines}`,
      columns: [Key.tilesOpened, Key.betMultiplier],
      data: multi.map(item => item.toFixed(2)),
    },
  }),
);

export const elements: TElement[] = [
  {
    type: 'header',
    content: Key.aboutHeader1,
  },
  {
    type: 'text',
    content: Key.aboutText1,
  },
  {
    type: 'text',
    content: Key.aboutText2,
  },
  {
    type: 'text',
    content: Key.aboutText3,
  },
  {
    type: 'header',
    content: Key.aboutHeader2,
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage1Title,
      src: Key.img_about1,
      caption: Key.aboutImage1Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage2Title,
      src: Key.img_about2,
      caption: Key.aboutImage2Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage3Title,
      src: Key.img_about3,
      caption: Key.aboutImage3Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage4Title,
      src: Key.img_about4,
      caption: Key.aboutImage4Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage5Title,
      src: Key.img_about5,
      caption: Key.aboutImage5Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage9Title,
      src: Key.img_about9,
      caption: Key.aboutImage9Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage10Title,
      src: Key.img_about10,
      caption: Key.aboutImage10Caption,
    },
  },
  {
    type: 'header',
    content: Key.aboutHeader3,
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage6Title,
      src: Key.img_about6,
      caption: Key.aboutImage6Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage7Title,
      src: Key.img_about7,
      caption: Key.aboutImage7Caption,
    },
  },
  {
    type: 'image',
    content: {
      title: Key.aboutImage8Title,
      src: Key.img_about8,
      caption: Key.aboutImage8Caption,
    },
  },
  {
    type: 'header',
    content: Key.aboutImage11Title,
  },
  {
    type: 'text',
    content: Key.aboutImage11Caption,
  },
  {
    type: 'header',
    content: Key.aboutHeader4,
  },
  {
    type: 'text',
    content: `${Key.aboutText4}${versionT}`,
  },
  {
    type: 'list',
    content: [
      {
        title: `${Key.aboutList1Title}${versionT}`,
        text: `${Key.aboutList1Text}${versionT}`,
      },
      {
        title: `${Key.aboutList2Title}${versionT}`,
        text: `${Key.aboutList2Text}${versionT}`,
      },
    ],
  },
  {
    type: 'header',
    content: Key.aboutHeader6,
  },
  {
    type: 'text',
    content: Key.aboutImage91Caption,
  },
  {
    type: 'text',
    content: Key.aboutImage92Caption,
  },
  {
    type: 'list',
    content: [
      {
        title: Key.aboutImage931ListTitle,
        text: Key.aboutImage931ListText,
      },
      {
        title: Key.aboutImage932ListTitle,
        text: Key.aboutImage932ListText,
      },
      {
        title: Key.aboutImage933ListTitle,
        text: Key.aboutImage933ListText,
      },
    ],
  },
  {
    type: 'text',
    content: Key.aboutImage94Caption,
  },
  {
    type: 'header',
    content: Key.aboutHeader5,
  },
  {
    type: 'text',
    content: Key.aboutText5,
  },
  {
    type: 'text',
    content: Key.aboutText51,
  },
  ...generatedMines,
  {
    type: 'header',
    content: Key.aboutHeader7,
  },
  {
    type: 'text',
    content: Key.aboutHeader8,
  },
  {
    type: 'header',
    content: Key.gameVersion,
  },
];
